module.exports = __webpack_public_path__ + "static/media/previous.360d0a40.svg";